import { useState, useEffect } from 'react';
import { api } from '../services/api';

/**
 * Manages chat message history: loads persisted messages on session change,
 * provides setMessages for streaming updates.
 *
 * @param {string} sessionId - Current chat session ID
 */
export default function useChatHistory(sessionId) {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const loadHistory = async () => {
      if (!sessionId) return;
      try {
        const response = await api.getChatHistory(sessionId);
        const history = response.data?.messages;
        if (Array.isArray(history) && history.length > 0) {
          const restored = history.map(m => ({
            id: m.message_id || `hist-${Date.now()}-${Math.random()}`,
            role: m.role === 'user' ? 'user' : 'agent',
            content: m.content || '',
            toolCalls: m.tool_calls || [],
            timestamp: m.created_at
              ? new Date(m.created_at).toLocaleTimeString()
              : '',
            loading: false,
            ...(m.attachments?.length > 0 ? { attachedFiles: m.attachments } : {}),
          }));
          setMessages(restored);
        }
      } catch (err) {
        console.error('Failed to load chat history:', err);
      }
    };

    loadHistory();
  }, [sessionId]);

  return { messages, setMessages };
}
